module.exports = __webpack_public_path__ + "media/our_mission/photo_1-d483ae07.webp";